import React, { Component } from "react"
import AnchorLink from "react-anchor-link-smooth-scroll"
import Scrollspy from "react-scrollspy"
import { Menu, X } from "react-feather"
import logo from "../../../images/day.png"
import { navigate } from "gatsby"
import firebase from "gatsby-plugin-firebase"

import { Container } from "../../global"
import {
  Nav,
  NavItem,
  Brand,
  StyledContainer,
  NavListWrapper,
  MobileMenu,
  Mobile,
  ActionsContainer,
} from "./style"

const NAV_ITEMS = ["How Day Works", "Community", "Bitcoin", "FAQ"]

export default class Navigation extends Component {
  state = {
    mobileMenuOpen: false,
    hasScrolled: false,
    user: [],
    showButton: false,
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)


    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({ user })
      } else {
        this.setState({ showButton: true })
      }
    })
  }

  handleScroll = (event) => {
    const scrollTop = window.pageYOffset

    if (scrollTop > 32) {
      this.setState({ hasScrolled: true })
    } else {
      this.setState({ hasScrolled: false })
    }
  }

  handleLogoClick = (event) => {
    navigate("https://www.trydayapp.com")
  }

  toggleMobileMenu = () => {
    this.setState((prevState) => ({
      mobileMenuOpen: !prevState.mobileMenuOpen,
    }))
  }

  closeMobileMenu = () => {
    if (this.state.mobileMenuOpen) {
      this.setState({ mobileMenuOpen: false })
    }
  }

  getNavAnchorLink = (item) => (
    <a href={`/#${item.toLowerCase()}`} title="hello">
      {item}
    </a>
  )

  getNavList = ({ mobile = false }) => (
    <NavListWrapper mobile={mobile}>
      <Scrollspy
        items={NAV_ITEMS.map((item) => item.toLowerCase())}
        currentClassName="active"
        mobile={mobile}
        offset={-64}
      >
        <NavItem key={"1"}>
          <a href={`/#how-it-works`} title="How Day works">
            How Day Works
          </a>
        </NavItem>
        <NavItem key={"2"}>
          <a href={`/#community`} title="The Day community">
            Community
          </a>
        </NavItem>
        <NavItem key={"3"}>
          <a href={`/#bitcoin`} title="Bitcoin rewards">
            Bitcoin
          </a>
        </NavItem>
        <NavItem key={"4"}>
          <a href={`/#faq`} title="Frequently asked questions">
            FAQ
          </a>
        </NavItem>
        <NavItem key={"5"}>
          <a href={`/subscriptions`} title="Support the Day community">
            Support Us
          </a>
        </NavItem>
      </Scrollspy>
    </NavListWrapper>
  )

  render() {
    const { mobileMenuOpen } = this.state

    return (
      <Nav {...this.props} scrolled={this.state.hasScrolled}>
        <StyledContainer>
          <Brand>
            <Scrollspy offset={-64} item={["top"]} currentClassName="active">
              <AnchorLink href="#" onClick={this.closeMobileMenu}>
                <img
                  src={logo}
                  alt="Day logo"
                  width="150px"
                  onClick={() => {
                    this.handleLogoClick()
                  }}
                />
              </AnchorLink>
            </Scrollspy>
          </Brand>
          <Mobile>
            <button
              onClick={this.toggleMobileMenu}
              style={{ color: "black", background: "none" }}
            >
              {this.state.mobileMenuOpen ? (
                <X size={24} alt="close menu" />
              ) : (
                <Menu size={24} alt="open menu" />
              )}
            </button>
          </Mobile>

          <Mobile hide>{this.getNavList({})}</Mobile>
        </StyledContainer>
        <Mobile>
          {mobileMenuOpen && (
            <MobileMenu>
              <Container>{this.getNavList({ mobile: true })}</Container>
            </MobileMenu>
          )}
        </Mobile>
      </Nav>
    )
  }
}
